import React from 'react';
import '../Footer.css';  // Optional: Import your custom styles for the bottom footer

const BottomFooter = () => {
  return (
    <div className="bottom-footer">
      <p>&copy; {new Date().getFullYear()} MoonsideRooms. All Rights Reserved. Powered by <a href='https://SoftUp.agency'>SoftUp Agency</a></p>
      <div className="footer-links">
        <a href="/terms">Property Terms & Conditions</a> | 
        <a href="/privacy">Privacy Policy</a>
      </div>
    </div>
  );
};

export default BottomFooter;
